// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3dpIS","backButtonWrapper":"style_backButtonWrapper__2rsIa","main":"style_main__29GeL","line":"style_line__3Jj1q"};